/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Singleton = /** @class */ (function () {
        function Singleton() {
            if (!Singleton._allowPrivateInstantiation) {
                throw new Error("Error: Instantiating an object of Singleton class is not allowed. Please use the instance method");
            }
        }
        Singleton.getInstance = function (className) {
            if (!this._instance) {
                Singleton._allowPrivateInstantiation = true;
                this._instance = new className();
                Singleton._allowPrivateInstantiation = false;
            }
            return this._instance;
        };
        Singleton.dispose = function () {
            this._instance = null;
        };
        Singleton._allowPrivateInstantiation = false;
        Singleton._instance = null;
        return Singleton;
    }());
    exports.Singleton = Singleton;
    var Factory = /** @class */ (function () {
        function Factory() {
        }
        Factory.create = function (className, args) {
            return this.createObject(className, args);
        };
        Factory.createObject = function (className, args) {
            if (args) {
                return new className(args);
            }
            else {
                var instance = Object.create(className.prototype);
                try {
                    var constructed = instance.constructor(args);
                    if (constructed) {
                        return constructed;
                    }
                    else {
                        return instance;
                    }
                }
                catch (e) {
                    return new instance.constructor(args);
                }
            }
        };
        return Factory;
    }());
    exports.Factory = Factory;
    var KeyMonikerProvider = /** @class */ (function () {
        function KeyMonikerProvider() {
        }
        KeyMonikerProvider.getKey = function () {
            throw new Error("This method needs to be implemented in derived classes");
        };
        return KeyMonikerProvider;
    }());
    exports.KeyMonikerProvider = KeyMonikerProvider;
    var Initializable = /** @class */ (function (_super) {
        __extends(Initializable, _super);
        function Initializable() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Initializable;
    }(KeyMonikerProvider));
    exports.Initializable = Initializable;
    var BaseManager = /** @class */ (function (_super) {
        __extends(BaseManager, _super);
        function BaseManager() {
            var _this = _super.call(this) || this;
            _this._instanceMap = {};
            return _this;
        }
        BaseManager.prototype.dispose = function () {
            var _this = this;
            Object.keys(this._instanceMap).forEach(function (key) {
                _this._deleteInstance(key);
            });
            this._instanceMap = {};
        };
        BaseManager.prototype.getAllObjects = function (instanceClass) {
            var instanceKey = instanceClass.getKey().toLowerCase();
            var instances = [];
            for (var instance in this._instanceMap) {
                if (this._instanceMap.hasOwnProperty(instance)) {
                    if (instance.indexOf(instanceKey) === 0) {
                        instances.push(this._instanceMap[instance]);
                    }
                }
            }
            return instances;
        };
        BaseManager.prototype.getObject = function (instanceClass, instanceId) {
            var argumentLength = instanceClass.prototype.constructor.length;
            if (argumentLength > 0) {
                var instanceKey = this._getInstanceKey(instanceClass, instanceId);
                var instance = this._instanceMap[instanceKey];
                if (!instance) {
                    throw new Error("Object requested is not created yet. Ensure that the object is created before it is queried. " + instanceClass);
                }
                else {
                    return instance;
                }
            }
            else {
                return this.createObject(instanceClass, instanceId, null);
            }
        };
        BaseManager.prototype.removeObject = function (instanceClass, instanceId) {
            var instanceKey = this._getInstanceKey(instanceClass, instanceId);
            this._deleteInstance(instanceKey);
        };
        BaseManager.prototype.createObject = function (instanceClass, instanceId, args) {
            var instanceKey = this._getInstanceKey(instanceClass, instanceId);
            var instance = this._instanceMap[instanceKey];
            if (!instance) {
                instance = Factory.createObject(instanceClass, null);
                this.onObjectCreated(instance, instanceId);
                this._instanceMap[instanceKey] = instance;
            }
            return instance;
        };
        BaseManager.prototype._getInstanceKey = function (instanceClass, instanceId) {
            var instanceKey = instanceClass.getKey();
            if (instanceId) {
                instanceKey = instanceKey + "." + instanceId;
            }
            return instanceKey.toLowerCase();
        };
        BaseManager.prototype._deleteInstance = function (instanceKey) {
            var instance = this._instanceMap[instanceKey];
            if (instance) {
                var disposeFunc = instance.__dispose;
                if (disposeFunc && typeof disposeFunc === "function") {
                    instance.__dispose();
                }
                delete this._instanceMap[instanceKey];
            }
        };
        return BaseManager;
    }(Singleton));
    exports.BaseManager = BaseManager;
    var Manager = /** @class */ (function (_super) {
        __extends(Manager, _super);
        function Manager() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Manager.prototype.onObjectCreated = function (instance, instanceId) {
            instance.initialize(instanceId);
        };
        return Manager;
    }(BaseManager));
    exports.Manager = Manager;
});
